export default {
  data() {
    return {

    }
  },
  methods: {
    setScrollPositionRef() {
      localStorage.setItem(this.$router.currentRoute.name, this.$refs.vscroll.$el.scrollTop)
    }
  },
  mounted() {
    console.warn('mixin load')
    if (this.isLoading) {
      const unwatch = this.$watch('isLoading', (v) => {
        if (!v) {
          this.$nextTick(() => {
            this.$nextTick(() => {
              if(localStorage.getItem(this.$router.currentRoute.name)) {
                const scrollTop = localStorage.getItem(this.$router.currentRoute.name)
                localStorage.removeItem(this.$router.currentRoute.name)
                this.$refs.vscroll.$el.scrollTop = parseInt(scrollTop)
              }
            })
          })
          unwatch()
        }
      })
    } else {
      this.$nextTick(() => {
        if(localStorage.getItem(this.$router.currentRoute.name)) {
          const scrollTop = localStorage.getItem(this.$router.currentRoute.name)
          localStorage.removeItem(this.$router.currentRoute.name)
          this.$refs.vscroll.$el.scrollTop = parseInt(scrollTop)
        }
      })
    }
  },
  beforeRouteEnter(to, from, next) {
    if(from.name !== 'Artikeldetails') {
      localStorage.removeItem(to.name)
    }
    next()
  }

}
